import GlowingBallLeft from "../../assets/glowing-ball-left.png";
import GlowingBallMiddle from "../../assets/glowing-ball-middle.png";
import GlowingBallMiddleTop from "../../assets/glowing-ball-middle-top.png";
import GlowingBallMiddleBottom from "../../assets/glowing-ball-middle-bottom.png";
import GlowingBallAlmostRight from "../../assets/glowing-ball-almost-right.png";
import GlowingBallRight from "../../assets/glowing-ball-right.png";
import AntenaLeft from "../../assets/antena-left.png";
import AntenaRight from "../../assets/antena-right.png";

const ImageBackground = () => {
  return (
    <>
      <img
        src={GlowingBallLeft}
        style={{
          position: "fixed",
          left: "0",
          top: "120px",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
        draggable={false}
      />
      <img
        src={AntenaLeft}
        style={{
          position: "fixed",
          left: "0",
          bottom: "0",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
        draggable={false}
      />
      <img
        src={AntenaRight}
        style={{
          position: "fixed",
          left: "5%",
          bottom: "0",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
        draggable={false}
      />
      <img
        src={GlowingBallMiddle}
        style={{
          position: "fixed",
          left: "50%",
          top: "25%",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
        draggable={false}
      />
      <img
        src={GlowingBallMiddleTop}
        style={{
          position: "fixed",
          left: "60%",
          top: "40%",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
        draggable={false}
      />
      <img
        src={GlowingBallMiddleBottom}
        style={{
          position: "fixed",
          left: "65%",
          top: "70%",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
        draggable={false}
      />
      <img
        src={GlowingBallAlmostRight}
        style={{
          position: "fixed",
          left: "90%",
          top: "30%",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
        draggable={false}
      />
      <img
        src={GlowingBallRight}
        style={{
          position: "fixed",
          right: "0",
          top: "10%",
          userSelect: "none",
          pointerEvents: "none",
        }}
        alt=""
        draggable={false}
      />
    </>
  );
};

export default ImageBackground;
